import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackgroundComponent from "../../components/background";
import LoadingModalComponent from "../../modals/loading-modal";
import { signIn } from "../../api/services";

export default function LockScreen() {
  const navigate = useNavigate();
  const name = localStorage.getItem("name");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await signIn(name, password);
      localStorage.setItem("name", res.data.name);
      localStorage.setItem("token", res.data.token);
      toast.success(`Сайн уу, ${res.data.name}!`);
      navigate("/e/list");
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <LoadingModalComponent show={loading} />
      <BackgroundComponent />
      <div className="account-pages py-auto position-relative">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-xxl-4 col-lg-5"
              style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}
            >
              <div className="card">
                <div className="card-header py-4 text-center border-bottom">
                  <a href="index.html">
                    <span><img src="assets/images/logo.png" alt="logo" height={66} /></span>
                  </a>
                </div>
                <div className="card-body p-4">
                  <div className="text-center w-75 m-auto">
                    <img src="assets/images/users/avatar-1.jpg" height={64} alt="user-image" className="rounded-circle shadow" />
                    <h4 className="text-dark-50 text-center mt-3 fw-bold">Hi!, {name}</h4>
                    <p className="text-muted mb-4">Нууц үгээ оруулан нэвтэрнэ үү</p>
                  </div>
                  <form action="#">
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">Нууц үг</label>
                      <div className="input-group input-group-merge">
                        <input
                          required
                          type={showPassword ? "text" : "password"}
                          id="password"
                          className="form-control"
                          placeholder="Нууц үгээ оруулна уу"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <div
                          className={`input-group-text ${showPassword ? "show-password" : ""}`}
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <span className={"password-eye"} />
                        </div>
                      </div>
                    </div>
                    <div className="mb-0 text-center">
                      <button className="btn btn-primary" type="submit" onClick={submit}>
                        <i className="mdi mdi-login me-1" /> Нэвтрэх
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <p className="my-auto"> ©2024 | Powered by </p>
                <img className="rounded ms-2" src="/assets/images/e24.png" width={20} height={20} />
                <p className="ms-1 my-auto">E24</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
